/* Top level history page. This page should get all titles from MongoDB and show them. Upon
   clicking on a title, a component should then show that entry. That component should be
   re-used on any page where a history entry needs to be shown. */

import React                           from 'react'
import Box                             from "@material-ui/core/Box"
import Paper                           from "@material-ui/core/Paper"

import HistoryCitationReadComponent   from '../Components/HistoryCitationReadComponent.js'
import HistoryEntries                  from '../Components/HistoryEntries.js'

const History = () => {
   return (
      <Box>
         <Paper style={{ marginTop: '50px', margin: '20px', backgroundColor: 'rgba(0, 0, 255, 0.05)' }} >
            <HistoryEntries page={'History'} />
            <HistoryCitationReadComponent />
         </Paper>
      </Box>
   )
}


export default History